import React from 'react';
import { Container } from 'reactstrap';

import SidebarLayout from '../../components/layout/SidebarLayout';
import PageSkeleton from '../../components/skeleton/PageSkeleton';
import SidebarSkeleton from '../../components/skeleton/SidebarSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const CATEGORY_PAGE_CHUNK_NAME = 'categoryPage';

export const CategoryPageFallback = ({ showSidebarSkeleton }) => {
  return (
    <Container className="CategoryPage__container">
      <SidebarLayout
        sidebarPlaceHolder={showSidebarSkeleton ? <SidebarSkeleton /> : null}
        content={<PageSkeleton />}
        contentPlaceHolder={<PageSkeleton />}
      />
    </Container>
  );
};

export const CategoryPage = createRouteLoadable(
  () =>
    import(/* webpackChunkName: "categoryPage" */ '../../pages/CategoryPage'),
  {
    fallback: <CategoryPageFallback showSidebarSkeleton />,
  }
);

export const MobileCategoryPage = createRouteLoadable(
  () =>
    import(/* webpackChunkName: "categoryPage" */ '../../pages/CategoryPage'),
  {
    fallback: <CategoryPageFallback showSidebarSkeleton={false} />,
  }
);
